import {useImoveisStore} from '../../context/DataContext'
import {MapView} from './MapView'
import {Imoveis} from '../../types'
import {Legenda} from '../SocioDemografico/Legenda'
import {styleM2Aluguel, styleTicketAluguel} from './variaveis'
interface MapVendaProps {
  height: number
  amostras: Imoveis[]
}

const Map3Dorm = ({height, amostras}: MapVendaProps) => {
  const {endereco} = useImoveisStore()

  if (!endereco) {
    return <></>
  }
  const filtered = amostras.filter((item) => item.quartos === 3)

  return (
    <>
      <div className='row'>
        <div className='col-6'>
          <MapView
            center={{
              lat: endereco?.latitude,
              lng: endereco?.longitude,
            }}
            layer={[]}
            json={undefined}
            dataImoveis={filtered}
            style={styleTicketAluguel}
            zoom={15}
            type='ticket'
          >
            <Legenda style={styleTicketAluguel} title={'Ticket'} visivel={true}></Legenda>
          </MapView>
        </div>
        <div className='col-6'>
          <MapView
            center={{
              lat: endereco?.latitude,
              lng: endereco?.longitude,
            }}
            layer={[]}
            json={undefined}
            dataImoveis={filtered}
            style={styleM2Aluguel}
            zoom={15}
            type='m2'
          >
            <Legenda style={styleM2Aluguel} title={'Preço m2'} visivel={true}></Legenda>
          </MapView>
        </div>
      </div>
    </>
  )
}

export default Map3Dorm
